import React from 'react';

import { SpecialistList as Specialist } from '../../models/Specialist';
import { Specialty } from '../../models/Specialty';

import HeadTitle from '../../components/HeadTitle';
import ContainerPage from '../../components/ContainerPage';
import Button from '../../components/Button';
import LoadingOverlay from '../../components/LoadingOverlay';
import Search from './components/Search';
import { Specialists } from './components/Specialists';
import { ModalFilter } from './components/ModalFilter';
import { FilterDisplay } from './components/FilterDisplay';

const WarningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';

import * as S from './styles';
import { useSpecialistList } from './index.model';
import { Page, useMainRouter } from '../../Router/pageComponents';
import useOnCloseSchedule from '../../hooks/useOnCloseSchedule';

const SpecialistList = () => {
  const {
    resetSearch,
    handleApplyFilters,
    specialists,
    selectedSpecialist,
    handleClickListItem,
    getSpecialistsByName,
    specialist,
    specialtyList,
    showSearchWrapper,
    loading,
    modalFilterVisible,
    areaExpertises,
    medicalFields,
    changeContextSearch,
    goTo,
    selectSpecialist,
    valueFilter,
    selectedSpecialty,
    handleCleanSelectedFilters,
    setModalFilterVisible,
    selectedFilters,
    setSpecialist,
    setSpecialtyList,
    addSpecialistsStore,
    findSpecialties,
    specialties,
    listUnitsFilter,
    setSearchTherm
  } = useSpecialistList();

  const { goBack: mainRouterGoBack, history } = useMainRouter();

  const { onCloseSchedule } = useOnCloseSchedule({
    isSpecialPage: false
  });

  function handleGoBack() {
    if (history.length === 1) {
      const [page] = history;

      if (page.page === Page.GENERAL) onCloseSchedule();
      else mainRouterGoBack();
    }
    if (history.length > 1) mainRouterGoBack();
  }

  return (
    <ContainerPage
      childrenFooter={
        specialists &&
        specialists.length > 0 &&
        !modalFilterVisible && (
          <>
            <Button
              title="Continuar"
              disabled={!specialist}
              onClick={() =>
                handleClickListItem({ type: 'SPECIALIST', item: specialist as Specialist, inputText: valueFilter })
              }
            />
          </>
        )
      }
      standardSpacing={showSearchWrapper}
    >
      <S.Container>
        <S.ListWrapper>
          {!showSearchWrapper ? (
            <>
              <HeadTitle
                title={specialists?.length ? 'Voltar' : 'Busque por médicos e especialidades'}
                goBack={() => {
                  if (specialists && specialists.length > 0) {
                    changeContextSearch(true);
                  } else handleGoBack();
                }}
              />

              <S.InputContainer>
                <Search
                  handleClickResult={handleClickListItem}
                  // handleSelectSpecialist={selectSpecialist}
                  // handleSelectSpecialist={specialist => {
                  //   console.log({ specialist });
                  // }}
                  handleClear={resetSearch}
                  loading={false}
                  // selectedSpecialist={selectedSpecialist}
                  // selectedSpecialist={undefined}
                  placeholder={selectedSpecialty?.name}
                  standardSpacing={false}
                  changeContext={() => {
                    changeContextSearch(!showSearchWrapper);
                  }}
                  rounded
                  initialValue={valueFilter}
                  clarIcon={false}
                  onChangeSearchTherm={setSearchTherm}
                />
              </S.InputContainer>

              {selectedSpecialty && (
                <S.Row isSpacedBetween isAlignedCenter hasMargin>
                  <S.ResultText>Resultados</S.ResultText>
                  <FilterDisplay
                    onResetFilter={() => {
                      handleCleanSelectedFilters();
                      handleClickListItem({
                        type: 'SPECIALTY',
                        item: selectedSpecialty as Specialty,
                        inputText: valueFilter,
                        filters: { expertise: [], medicalField: [], units: [] }
                      });
                    }}
                    onFilterPress={() => setModalFilterVisible(true)}
                    filtersCounter={selectedFilters}
                  />
                </S.Row>
              )}

              <Specialists
                specialistList={specialists ? specialists : []}
                specialty={selectedSpecialty?.name}
                selectedSpecialist={specialist}
                handleSelectSpecialist={specialist => {
                  setSpecialist(specialist);
                  // selectSpecialist(specialist);
                }}
              />

              {(!specialists || specialists?.length === 0) &&
                selectedSpecialty &&
                (selectedFilters.expertise.length > 0 ||
                  selectedFilters.medicalField.length > 0 ||
                  selectedFilters.units.length > 0) &&
                !loading && (
                  <S.EmptyContainer>
                    <img src={WarningIcon} />
                    <p>Não encontramos resultados para os filtros aplicados</p>
                  </S.EmptyContainer>
                )}
            </>
          ) : (
            <Search
              fetchSpecialists={filter => {
                setSpecialtyList(findSpecialties(filter));
                if (filter.length <= 2) addSpecialistsStore([]);
                if (filter.length > 2) getSpecialistsByName(filter);
              }}
              handleClickResult={handleClickListItem}
              // handleSelectSpecialist={selectSpecialist}
              handleClear={resetSearch}
              loading={false}
              // selectedSpecialist={selectedSpecialist}
              initialValue={valueFilter}
              specialistList={specialists ? specialists : []}
              specialtyList={specialtyList}
              changeContext={() => {
                changeContextSearch(!showSearchWrapper);
              }}
              standardSpacing
              rounded
              handleClearIcon={() => {
                setSpecialtyList(specialties);
                addSpecialistsStore([]);
              }}
              onChangeSearchTherm={setSearchTherm}
            />
          )}
        </S.ListWrapper>
      </S.Container>

      <ModalFilter
        visible={modalFilterVisible}
        units={listUnitsFilter}
        areaExpertises={areaExpertises}
        medicalFields={medicalFields}
        onClose={() => setModalFilterVisible(false)}
        onApply={handleApplyFilters}
      />
      <LoadingOverlay loading={loading} />
    </ContainerPage>
  );
};

export default SpecialistList;
